/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  OTELLogsPayload,
  OTELLogsPayload$Outbound,
  OTELLogsPayload$outboundSchema,
} from "../components/otellogspayload.js";

export type HooksNumberLogsSecurityOption1 = {
  deviceAgentTokenHeaderAuthorization: string;
  projectSlugHeaderGramProject: string;
};

export type HooksNumberLogsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type HooksNumberLogsSecurity = {
  option1?: HooksNumberLogsSecurityOption1 | undefined;
  option2?: HooksNumberLogsSecurityOption2 | undefined;
};

export type HooksNumberLogsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  otelLogsPayload: OTELLogsPayload;
};

/** @internal */
export type HooksNumberLogsSecurityOption1$Outbound = {
  device_agent_token_header_Authorization: string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const HooksNumberLogsSecurityOption1$outboundSchema: z.ZodMiniType<
  HooksNumberLogsSecurityOption1$Outbound,
  HooksNumberLogsSecurityOption1
> = z.pipe(
  z.object({
    deviceAgentTokenHeaderAuthorization: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      deviceAgentTokenHeaderAuthorization:
        "device_agent_token_header_Authorization",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberLogsSecurityOption1ToJSON(
  hooksNumberLogsSecurityOption1: HooksNumberLogsSecurityOption1,
): string {
  return JSON.stringify(
    HooksNumberLogsSecurityOption1$outboundSchema.parse(
      hooksNumberLogsSecurityOption1,
    ),
  );
}

/** @internal */
export type HooksNumberLogsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const HooksNumberLogsSecurityOption2$outboundSchema: z.ZodMiniType<
  HooksNumberLogsSecurityOption2$Outbound,
  HooksNumberLogsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberLogsSecurityOption2ToJSON(
  hooksNumberLogsSecurityOption2: HooksNumberLogsSecurityOption2,
): string {
  return JSON.stringify(
    HooksNumberLogsSecurityOption2$outboundSchema.parse(
      hooksNumberLogsSecurityOption2,
    ),
  );
}

/** @internal */
export type HooksNumberLogsSecurity$Outbound = {
  Option1?: HooksNumberLogsSecurityOption1$Outbound | undefined;
  Option2?: HooksNumberLogsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const HooksNumberLogsSecurity$outboundSchema: z.ZodMiniType<
  HooksNumberLogsSecurity$Outbound,
  HooksNumberLogsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => HooksNumberLogsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => HooksNumberLogsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function hooksNumberLogsSecurityToJSON(
  hooksNumberLogsSecurity: HooksNumberLogsSecurity,
): string {
  return JSON.stringify(
    HooksNumberLogsSecurity$outboundSchema.parse(hooksNumberLogsSecurity),
  );
}

/** @internal */
export type HooksNumberLogsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  OTELLogsPayload: OTELLogsPayload$Outbound;
};

/** @internal */
export const HooksNumberLogsRequest$outboundSchema: z.ZodMiniType<
  HooksNumberLogsRequest$Outbound,
  HooksNumberLogsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    otelLogsPayload: OTELLogsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      otelLogsPayload: "OTELLogsPayload",
    });
  }),
);

export function hooksNumberLogsRequestToJSON(
  hooksNumberLogsRequest: HooksNumberLogsRequest,
): string {
  return JSON.stringify(
    HooksNumberLogsRequest$outboundSchema.parse(hooksNumberLogsRequest),
  );
}
